import { deserialize, serialize } from "class-transformer";
import { DeliveryAddress } from "../../shared/models/form/delivery-address.model";
import { DeliveryMethod } from "../../shared/models/form/delivery-method.model";
import { Control, Param } from "../../form-v2/form-model/Control";
import { KrokStep } from "../../form-v2/form-model/StepKrok";
import { Parameter } from "src/app/shared/models/form-model/models/form-controlls.model";
import { Order } from "../../form-v2/form-model/Order";
import { Modul } from "../../form-v2/form-model/Modul";
import { GrupaKrokow } from "../../form-v2/form-model/GrupaKrokow";
import { TypEnum } from "../../form-v2/form-model/TypEnum";
import { FormV2ServiceService } from "../../form-v2/form-v2-service.service";
import { Delivery } from "../../form-v2/form-model/Delivery";
import { Supervisor } from "../../form-v2/form-model/Supervisor";
import * as _ from 'lodash';
import { FormDataSend } from "../../form-v2/form-model/FormDataSend";
import { KindOper } from '../../shared/enums/kind-oper-enum';
import { Parametr } from "src/app/pomocnicze/parametry_wybrane";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { UniversalDialogComponent } from "src/app/shared/components/universal-dialog/universal-dialog.component";
import { DialogData } from "src/app/shared/models/dialog/dialog-data.model";
import { Kim } from "src/app/shared/models/form-model/kim.model";
import { FormService } from "src/app/shared/service/form.service";
import { FileControl } from "src/app/shared/models/form/file-control.model";
import { FormDataV2Save } from "../../form-v2/form-model/FormDataV2Save";
import { KimSave } from "../../form-v2/form-model/KimSave";
import * as htmlToImage from 'html-to-image';
import { HttpEventType, HttpRequest } from "@angular/common/http";
import { TresciService } from "src/app/tresci.service";
import { ModulMulti } from "./ModulMulti";
import { Valuation } from "./Valuation";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject } from "rxjs";

export class FormDataMulti {

    //kroki:KrokStep[] = [];

    zapisuje:boolean = false;

    isCache: boolean = false;
    public ParameterExtensions:Kim[] = [];

    

    Parameters:Parameter[] = [];

    produktPrefix: string;
    orderId: any;
    kindOper: any;

    public naglowekW:KrokStep;
    public naglowek:KrokStep;
    public moduly:ModulMulti[] = [];
    public stopka:KrokStep;

    culture: string;
    IsTrader: boolean;
    wczytywanie: number = 0;

    id_parent:number = null;

    TechVersion: Number;
    ValuationVersion: Number;
    IsFooter: boolean;
    IsModule: boolean;
    IsModuleFooter: boolean;

    IloscWczytana: Number = 0;
    ModuleCount: Number = 1;
    system: string;
    systemPrefix: string = "ALL";
    typ: string;
    widoczny_modul = 0;
    isFooter: boolean = false;
    isModule: boolean = false;
    currency: string;
    wczytywanie_wyceny: boolean = false;
    kim: KrokStep = null;

    ostatnieParametry;
    ostatniKrok;
    ostatnieParametryValuation;
    ostatniePrevParametryValuation;
    valuationStep;
    step:string;
    wczytywanie_all: boolean = false;
    generatePrev:boolean = false;
    
    
    public TranslationLoaded: BehaviorSubject<boolean>;
    
    constructor(private tresci:TresciService, private router: Router, private translateService: TranslateService, private activatedRoute: ActivatedRoute){
        
        this.activatedRoute.params.subscribe((params) => {
            if(params.system != null && params.system != ""){
                this.systemPrefix = params.system;
                this.typ = params.system;
                this.GetSystemByTyp(this.typ);
                this.generatePrev = true;

                localStorage.site = this.typ;
                window['site'] = this.typ;
                // console.log("site", params.system);
                this.tresci.wczytaj_tresci_tlumaczen2(window['culture'], this.typ);
                this.TranslationLoaded = new BehaviorSubject(false);
            
                this.translateService.reloadLang(this.translateService.currentLang).subscribe((x) => this.TranslationLoaded.next(true));
            }
        });
        
    }


    ZmienModul(numer, formService:FormV2ServiceService){
        this.widoczny_modul = numer;
        if(numer == -1){
            this.WczytajKim(formService);
        }
    }
    WczytajKim(formService:FormV2ServiceService) {
         // console.log("header f");
        
        
        // console.log("wczytuje WczytajKim");
         this.wczytywanie++;
     
            
        this.ostatnieParametry = this.GetParams(0,0);
        this.step = "Position";
        formService.getStepMulti(this.systemPrefix, this.culture, this.isCache, this.IsTrader,this.ostatnieParametry,"Position", this.GetPrevParams(0,0)).
          subscribe((data) => {
            data.Controlls = data.Controlls.filter(x => x.Section == "Footer");
            this.ostatniKrok = data;
            this.isCache = true;
             this.isFooter = data.IsFooter;
             this.isModule = data.IsModule;

             var k:KrokStep = data;
             k.Position = 0;
             k.Module = 0;
             // console.log("params", data, this.Parameters);
             var step:KrokStep = new KrokStep(k, this.Parameters, []);
             //this.naglowek = step;
             if(this.kim == null){
                this.kim = step;
             }
             this.EdytujKrok(this.kim, step);
          
            // console.log("po zapisie 0");
            // this.wczytywanie--;
          }, (err) => {
            // console.log("blad zapisu");
            this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          }, () => {
              this.wczytywanie--;
              // console.log("skonczyl WczytajKim");
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          });
        return false;
    }
  
    DodajModul(formService:FormV2ServiceService){
        // console.log("DodajModul f");
        this.wczytywanie++;
        // console.log("wczytuje DodajModul");
     
            
        this.ostatnieParametry = this.GetParams(0,0);
        this.step = "Header";
        
        formService.getStepMulti(this.systemPrefix, this.culture, this.isCache, this.IsTrader,this.ostatnieParametry,"Header", this.GetPrevParams(0,0)).
          subscribe((data) => {
            data.Controlls = data.Controlls.filter(x => x.Section == "ModuleHeader");
            this.ostatniKrok = data;
            this.isCache = true;
            this.moduly.push(new ModulMulti());
            this.widoczny_modul = this.moduly.length - 1;

             var k:KrokStep = data;
             k.Position = 0;
             k.Module = this.widoczny_modul + 1;
             var step:KrokStep = new KrokStep(k, this.Parameters, []);
             //this.moduly[this.widoczny_modul].moduleNg = step;
             if(this.moduly[this.widoczny_modul].moduleNg == null){
                this.moduly[this.widoczny_modul].moduleNg = step;
             }
             this.EdytujKrok(this.moduly[this.widoczny_modul].moduleNg, step);
             if(this.moduly[this.widoczny_modul].pozycje.length == 0){
                this.Add(formService, this.widoczny_modul);
             }

            //   // console.log("po zapisie 0");
            // this.wczytywanie--;
          }, (err) => {
            // console.log("blad zapisu");
            this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          }, () => {
              // console.log("skonczyl DodajModul");
              this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          });
        return false;

    }
    WczytajMod(formService:FormV2ServiceService){
        this.wczytywanie++;
        // console.log("wczytuje WczytajMod");
     
            
        this.ostatnieParametry = this.GetParams(0,0);
        this.step = "Header";
        
        formService.getStepMulti(this.systemPrefix, this.culture, this.isCache, this.IsTrader,this.ostatnieParametry,"Header", this.GetPrevParams(0,0)).
          subscribe((data) => {
            data.Controlls = data.Controlls.filter(x => x.Section == "ModuleHeader");
            this.isCache = true;
                this.ostatniKrok = data;
                var i = 1;
                this.moduly.forEach(element => {
                    // console.log("WczytajMod " + i);
                    var k:KrokStep = data;
                    k.Position = 0;
                    k.Module = i;
                    var step:KrokStep = new KrokStep(k, this.Parameters, []);
                    
                    if(this.moduly[i - 1].moduleNg == null){
                        this.moduly[i - 1].moduleNg = step;
                    }
                    this.EdytujKrok(this.moduly[i - 1].moduleNg, step);
                    if(this.moduly[i - 1].pozycje.length == 0){
                        this.Add(formService, i - 1);
                    } else {
                        this.moduly[i - 1].pozycje.forEach(p => {
                            this.position(formService, k.Module.valueOf(), p.Position.valueOf());
                        });
                        
                    }
                    i++;
                });
            
            

              //  // console.log("po zapisie 0");
            // this.wczytywanie--;
          }, (err) => {
            // console.log("blad zapisu");
            this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          }, () => {
              // console.log("skonczyl WczytajMod");
              this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          });
        return false;
    }
    WczytajModFooterNumer(formService: FormV2ServiceService, module: number) {
        // console.log("WczytajModNumer ", module);
        this.wczytywanie++;
        // console.log("wczytuje WczytajModFooterNumer");
     
            
        this.ostatnieParametry = this.GetParams(0,0);
        this.step = "Header";
        formService.getStepMulti(this.systemPrefix, this.culture, this.isCache, this.IsTrader,this.ostatnieParametry,"Position", this.GetPrevParams(0,0)).
          subscribe((data) => {
            
                data.Controlls = data.Controlls.filter(x => x.Section == "ModuleFooter");
                this.isCache = true;
                this.ostatniKrok = data;
                if(data.Controlls.length > 0){
                    var k2:KrokStep = data;
                    k2.Position = 0;
                    k2.Module = module;
                    
                    var step2:KrokStep = new KrokStep(k2, this.Parameters, []);
                    
                    if(this.moduly[module - 1].moduleFooter == null){
                        this.moduly[module - 1].moduleFooter = step2;
                    }
                    this.EdytujKrok(this.moduly[module - 1].moduleFooter, step2);
                }
             

             this.czyPoprawne();
             // console.log("po zapisie 0");
            // this.wczytywanie--;
          }, (err) => {
            // console.log("blad zapisu");
            this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          }, () => {
              // console.log("skonczyl WczytajModFooterNumer");
              this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          });
        return false;
    }

     WczytajModNumer(formService: FormV2ServiceService, module: number) {
        // console.log("WczytajModNumer ", module);
        this.wczytywanie++;
        // console.log("wczytuje WczytajModNumer");
     
            
        this.ostatnieParametry = this.GetParams(0,0);
        this.step = "Header";
        formService.getStepMulti(this.systemPrefix, this.culture, this.isCache, this.IsTrader,this.ostatnieParametry,"Header", this.GetPrevParams(0,0)).
          subscribe((data) => {
            data.Controlls = data.Controlls.filter(x => x.Section == "ModuleHeader");
            this.isCache = true;
            this.ostatniKrok = data;
            if(this.moduly.length >= module){
                // console.log("WczytajM ", module);
                  var k:KrokStep = data;
                    k.Position = 0;
                    k.Module = module;
                    var step:KrokStep = new KrokStep(k, this.Parameters, []);
                    // this.moduly[module - 1].moduleNg = step;
                    if(this.moduly[module - 1].moduleNg == null){
                        this.moduly[module - 1].moduleNg = step;
                    }
                    this.EdytujKrok(this.moduly[module - 1].moduleNg, step);

                    if(this.moduly[module - 1].pozycje.length == 0){
                        this.Add(formService, module - 1); 
                    } else {
                        this.moduly[module - 1].pozycje.forEach(p => {
                            this.position(formService, k.Module.valueOf(), p.Position.valueOf());
                        });
                    }
                   
            }
             // console.log("po zapisie 0");
            // this.wczytywanie--;
          }, (err) => {
            // console.log("blad zapisu");
            this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          }, () => {
              // console.log("skonczyl WczytajModNumer");
              this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          });
        return false;
    }

GetFirstStep(formService:FormV2ServiceService){
        // console.log("header f");
        
        
         this.wczytywanie++;
        // console.log("wczytuje headerW");
     
            this.ostatnieParametry = this.GetParams(0,0);
        this.step = null;
        
        formService.getStepMulti("ALL", this.culture, this.isCache, this.IsTrader,this.ostatnieParametry,null, this.GetPrevParams(0,0)).
          subscribe((data) => {
            data.Controlls = data.Controlls.filter(x => x.Section == "Header");
            //this.isCache = true;
            this.ostatniKrok = data;
             //this.isFooter = data.IsFooter;
             //this.isModule = data.IsModule;

             var k:KrokStep = data;
             k.Position = 0;
             k.Module = 0;
             // console.log("params", data, this.Parameters);
             var step:KrokStep = new KrokStep(k, this.Parameters, []);
             //this.naglowek = step;
             if(this.naglowekW == null){
                this.naglowekW = step;
             }
             this.EdytujKrok(this.naglowekW, step);

          }, (err) => {
            // console.log("blad zapisu");
            this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          }, () => {
              // console.log("skonczyl headerW");
              this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          });
        return false;
        
    }


    
    header(formService:FormV2ServiceService){
        // console.log("header f");
        
        
         this.wczytywanie++;
        // console.log("wczytuje header");
     
            this.ostatnieParametry = this.GetParams(0,0);
        this.step = null;
        
        formService.getStepMulti(this.systemPrefix, this.culture, this.isCache, this.IsTrader,this.ostatnieParametry,null, this.GetPrevParams(0,0)).
          subscribe((data) => {
            data.Controlls = data.Controlls.filter(x => x.Section == "Header");
            this.isCache = true;
            this.ostatniKrok = data;
             this.isFooter = data.IsFooter;
             this.isModule = data.IsModule;

             var k:KrokStep = data;
             k.Position = 0;
             k.Module = 0;
             // console.log("params", data, this.Parameters);
             var step:KrokStep = new KrokStep(k, this.Parameters, []);
             //this.naglowek = step;
             if(this.naglowek == null){
                this.naglowek = step;
             }
             this.EdytujKrok(this.naglowek, step);


            if(this.widoczny_modul == -1){
                this.WczytajKim(formService);
            }

            if(this.moduly.length == 0){
                this.DodajModul(formService);
            } else {
                this.WczytajMod(formService);
                
            }
            
                
            
          
            //   // console.log("po zapisie 0");
            // this.wczytywanie--;
          }, (err) => {
            // console.log("blad zapisu");
            this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          }, () => {
              // console.log("skonczyl header");
              this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          });
        return false;
        
    }
    
    
    
    ZmianaParametru(control:Control, formService:FormV2ServiceService){
        
        this.czyPoprawne();
        this.DodajParametr(control);
        this.GetSystem();
        this.GetTyp();

        if(control.ControlType != "Kim" && control.NotAffectToOtherControls == 0){
            if(control.KeyName == "Jakatechnologia"){

                localStorage.site = this.typ;
                window['site'] = this.typ;
                // console.log("site", params.system);
                this.tresci.wczytaj_tresci_tlumaczen2(window['culture'], this.typ);
                this.TranslationLoaded = new BehaviorSubject(false);
            
                this.translateService.reloadLang(this.translateService.currentLang).subscribe((x) => this.TranslationLoaded.next(true));
            }
            // console.log('control', control, this.system);
            if(control.Section == "Header") { //} control.Position == 0 && control.Module == 0){
                this.header(formService);
            } else if(control.Section == "ModuleHeader") { //control.Position == 0 && control.Module != 0){
                this.WczytajModNumer(formService, control.Module.valueOf());
            } else if(control.Section == "Position"){

                this.position(formService, control.Module.valueOf(), control.Position.valueOf());
                
                if(this.generatePrev){
                    var position = control.Position.valueOf();
                    while(this.moduly[control.Module.valueOf() - 1].pozycje.length > position){
                        this.position(formService, control.Module.valueOf(), ++position);
                    }
                }
            } else if(control.Section == "ModuleFooter"){
                this.WczytajModFooterNumer(formService, control.Module.valueOf());
            }
        }
    }

    
    czyPoprawne() {
        if(this.naglowek != null){
            this.naglowek.poprawne = this.naglowek.czyPoprawne();
                var ile_pop_mod = 0
            this.moduly.forEach(mod => {
                mod.poprawne = true;
                mod.moduleNg.poprawne = mod.moduleNg.czyPoprawne();
                if(!mod.moduleNg.poprawne){
                    mod.poprawne = false; 
                }
                var ile_pop = 0;
                mod.pozycje.forEach(poz => {
                    poz.poprawne = poz.czyPoprawne();
                    if(poz.poprawne){
                        ile_pop++;
                    } else {
                        mod.poprawne = false; 
                    }
                });
                if(ile_pop == 0){
                        mod.moduleNg.poprawne = false;
                }
                if(mod.moduleNg.poprawne){
                    ile_pop_mod++;
                }
            });
            if(ile_pop_mod == 0){
                this.naglowek.poprawne = false;
            }
        }
        

    }
   
    DodajParametr(control:Control){
        var byl = false;
        this.Parameters.forEach(par => {
            // console.log(par.Key, par.Module);
            if(par.Key == control.KeyName && par.Module == control.Module && par.Position == control.Position){
                // console.log("edytuje par", control);
                byl = true;
                par.Value = control.wybrany.Value;
                par.DisplayValue = control.wybrany.DisplayValue;
                par.DisplayValueCs = control.wybrany.DisplayValueCs;
                par.DisplayValueDe = control.wybrany.DisplayValueDe;
                par.DisplayValueEn = control.wybrany.DisplayValueEn;
                par.DisplayValueFr = control.wybrany.DisplayValueFr;
                par.DisplayValueIt = control.wybrany.DisplayValueIt;
                par.DisplayValuePl = control.wybrany.DisplayValuePl;
                par.Module = control.Module.valueOf();
                par.Position = control.Position.valueOf();
            }
            // console.log(par.Key, par.Module, control.Module.valueOf());
        });
        if(!byl){
            var p = new Parameter();
                // console.log("dodaje par", control);
                p.Value = control.wybrany.Value;
                p.DisplayValue = control.wybrany.DisplayValue;
                p.DisplayValueCs = control.wybrany.DisplayValueCs;
                p.DisplayValueDe = control.wybrany.DisplayValueDe;
                p.DisplayValueEn = control.wybrany.DisplayValueEn;
                p.DisplayValueFr = control.wybrany.DisplayValueFr;
                p.DisplayValueIt = control.wybrany.DisplayValueIt;
                p.DisplayValuePl = control.wybrany.DisplayValuePl;
                p.Module = control.Module.valueOf();
                p.Position = control.Position.valueOf();
                p.Key = control.KeyName;
            this.Parameters.push(p);
        }
        
    }
    CzyPoprawneCalosc(){
        if(this.naglowek == null || !this.naglowek.poprawne){
            return false;
        } else {
            var poprawne = true;
                this.moduly.forEach(mod => {
                    if(!mod.moduleNg.poprawne){
                        poprawne = false;
                    } 
                    mod.pozycje.forEach(poz => {
                        if(!poz.poprawne){
                            poprawne = false;
                        }
                    });
                });
            return poprawne;
        }
    }
CzyPoprawneWycena(){
    if(this.naglowek == null || !this.naglowek.poprawne){
            return false;
        } else {
           
                /////////////////////
                var ile_mod_pop = 0;
                this.moduly.forEach(mod => {
                    if(mod.moduleNg.poprawne){
                        ile_mod_pop++;
                    } 
                });
             if(ile_mod_pop == 0){
                return false;
             } else {
                return true;
             }
             
             
                
        }
}

 ustawModPoz(numer, formService) {
         var m = 1;
                this.moduly.forEach(mod => {
                    var lp = 1;
                    mod.moduleNg.Controlls.forEach(con => {
                            con.Module = m;
                            con.Position = lp;
                            if(con.wybrany != null){
                                con.wybrany.Module = m;
                                con.wybrany.Position = lp;
                                this.DodajParametr(con);
                            }
                        });
                    mod.pozycje.forEach(poz => {
                        poz.Module = m;
                        poz.Position = lp;
                        poz.Controlls.forEach(con => {
                            con.Module = m;
                            con.Position = lp;
                            if(con.wybrany != null){
                                con.wybrany.Module = m;
                                con.wybrany.Position = lp;
                                this.DodajParametr(con);
                            }
                        });
                        lp++;
                    });
                    m++;
                });
                if(this.generatePrev && formService != null){
                    if(numer > 0){
                        this.moduly[numer - 1].pozycje.forEach(poz => {
                                this.position(formService, poz.Module.valueOf(), poz.Position.valueOf());
                        });
                    }
                }
              
    }

GetAllParamsVal(){
       
        if(this.naglowek == null || !this.naglowek.poprawne){
            return [];
        } else {
            var p:Parameter[] = [];
            this.naglowekW.Controlls.forEach(con => {
                    if(con.wybrany.Key != 'X'){
                        //p.push(con.wybrany);
                        this.DodajDoParam(p, con, 0, 0);
                    }
                }); 
             this.naglowek.Controlls.forEach(con => {
                    // console.log('ng', con);
                    //if(!con.poprawne || con.bladKontrolki){
                    //    blad = true;
                    //}
                    if(con.wybrany.Key != 'X'){
                        //p.push(con.wybrany);
                        this.DodajDoParam(p, con, 0, 0);
                    }
                });
                
                /////////////////////
                var m = 1;
                
                var wyliczane_mod: Parameter[] = [];
                this.moduly.forEach(mod => {
                    var lp = 1;
                    var wyliczane: Parameter[] = [];
                    if(mod.moduleNg.poprawne){
                        this.moduly[m - 1].moduleNg.Controlls.forEach(con => {
                            // console.log('ng', con);
                            
                            if(con.wybrany.Key != 'X'){
                                //p.push(con.wybrany);
                                this.DodajDoParam(p, con, m, 0);
                                this.WyliczDodatkowe(wyliczane_mod, con.wybrany);
                            }
                        });
                        if(this.moduly[m - 1].moduleFooter != null){
                            this.moduly[m - 1].moduleFooter.Controlls.forEach(con => {
                                // console.log('ng', con);
                                
                                if(con.wybrany.Key != 'X'){
                                    //p.push(con.wybrany);
                                    this.DodajDoParam(p, con, m, 0);
                                }
                            });
                        }

                        mod.pozycje.forEach(poz => {
                            if(poz.poprawne){
                                this.moduly[m - 1].pozycje[lp - 1].Controlls.forEach(con => {
                                    // console.log('poz ' + lp , con);
                                    if(con.wybrany.Key != 'X'){
                                        //p.push(con.wybrany);
                                        this.DodajDoParam(p, con, m, lp);
                                        this.WyliczDodatkowe(wyliczane, con.wybrany);
                                    }
                                });
                            }
                            lp++;
                        });
                    }
                    m++;
                    wyliczane.forEach(w => {
                        p.push(w);
                    });
                });
             if(p.length > 0){
                this.DodajDoParamString(p,"TAK", 0, 0, "WycenaUproszczona");
             }
             
             return p;
                
        }
    }
    

    GetAllParams(){
       
        if(this.naglowek == null){
            return [];
        } else {
            var p:Parameter[] = [];
             this.naglowek.Controlls.forEach(con => {
                    // console.log('ng', con);
                    
                    if(con.wybrany.Key != 'X'){
                        //p.push(con.wybrany);
                        this.DodajDoParam(p, con, 0, 0);
                    }
                });
            
                /////////////////////
                var m = 1;
                this.moduly.forEach(mod => {
                    var lp = 1;

                    this.moduly[m - 1].moduleNg.Controlls.forEach(con => {
                        // console.log('ng', con);
                        
                        if(con.wybrany.Key != 'X'){
                            //p.push(con.wybrany);
                            this.DodajDoParam(p, con, m, 0);
                        }
                    });

                    mod.pozycje.forEach(poz => {
                       
                         this.moduly[m - 1].pozycje[lp - 1].Controlls.forEach(con => {
                            // console.log('poz ' + lp , con);
                            if(con.wybrany.Key != 'X'){
                                //p.push(con.wybrany);
                                this.DodajDoParam(p, con, m, lp);
                            }
                        });


                        lp++;
                    });
                    m++;
                });
          
             this.DodajDoParamString(p,"TAK", 0, 0, "WycenaUproszczona");
             return p;
                
        }
    }
    getFinalPriceMod(numer_mod){
        var cena = 0;
        if(this.moduly.length > numer_mod){
             if(this.moduly[numer_mod].pozycje != null){
                this.moduly[numer_mod].pozycje.forEach(poz => {
                    cena+= poz.getFinalPriceNumber();
                    this.currency = poz.getCurrency();
                });
            }
        }
       
        return cena;
    }
    getFinalPrice(){
        var cena = 0;
        this.moduly.forEach(mod => {
            if(mod.pozycje != null){
                mod.pozycje.forEach(poz => {
                    cena+= poz.getFinalPriceNumber();
                });
            }
           
        });
        if(this.ParameterExtensions != null){
            this.ParameterExtensions.forEach(param => {
                cena+=param.BasicPrice * param.Quantity;
            });

        }
        return cena;
    }
   
    PrzeliczWycene(formService:FormV2ServiceService){
         
         var params:Parameter[] = this.GetAllParamsVal();
         if(params.length > 0){
            this.wczytywanie_wyceny = true;
            this.ostatnieParametryValuation = params;
            this.ostatniePrevParametryValuation = params;
            this.valuationStep = "Modul";
                    formService.getValuation(this.typ, this.culture, false, this.IsTrader,params,"Modul", params).
                        subscribe((valuations) => {
                                this.wczytywanie_wyceny = false;
                                valuations.forEach(valuation => {
                                    // console.log("valuation", valuation, valuation.Module - 1, valuation.Position - 1,this.moduly);
                                    this.moduly[valuation.Module - 1].pozycje[valuation.Position - 1].Valuation = valuation;
                                });
                                
                            }, (err) => {
                                // console.log("blad zapisu");
                                this.wczytywanie_wyceny = false;
                            }, () => {
                                // console.log("po zapisie");
                                this.wczytywanie_wyceny = false;
                            });
         }
          
        
    }
    public save(formService:FormV2ServiceService){
            
            this.wczytywanie_all = true;
            
    
    
            
            var formData:FormDataSend = new FormDataSend();
            formData.Parameters = this.GetAllParams();

                // this.updateParameterExtensions();
                formData.ParameterExtensions = this.ParameterExtensions;
                formData.ContractorNumber = JSON.parse(sessionStorage.getItem('_slc')).ContractorNumber;
                
                formData.Culture = this.culture;
                formData.DeliveryMethod = "ODBIOR WLASNY";
                formData.DeliveryMethodId = "ODBIOR WLASNY";
                formData.DeliveryAddressId = null;
                
                
                if(this.kindOper === KindOper.Copy){
                    formData.CopiedOrderId = this.orderId;
                    formData.Id = 0;
                } else {
                    formData.CopiedOrderId = null;
                    formData.Id = this.orderId;
                }
                formData.IsCache = true;
                
                formData.IsComplaint = null;
        
                formData.IsTrader = this.IsTrader;
                formData.ProductPrefix = this.typ;
                formData.TechnologyVersion = this.TechVersion;
                formData.ParentId = this.id_parent;
                
                formData.Valuation = true;
                
                // console.log("form", formData);
                //this.wczytywanie = false;
                //this.zapisuje = false;
                // console.log("zam", formData);
                formService.AddorUpdateActiveFormOrderWithFiles(formData, []).
                subscribe((data) => {
                    
                  this.wczytywanie_all = false;
                  this.zapisuje = false;
                  localStorage.setItem('goToPage', '');
                  this.router.navigate(['Valuations']);
                  
                  
                }, (err) => {
                    // console.log("blad zapisu");
                    this.wczytywanie_all = false;
                    this.zapisuje = false;
                }, () => {
                    // console.log("po zapisie");
                    this.wczytywanie_all = false;
                    this.zapisuje = false;
                }
                
                );
            
            
        }
    
    position(formService:FormV2ServiceService, module, position){
        // console.log("position f", module, position);
        if(position > 0){
            this.wczytywanie++;
            // console.log("wczytuje position");
            this.ostatnieParametry = this.GetParams(position, module);
            this.step = "Modul";
            formService.getStepMulti(this.systemPrefix, this.culture, this.isCache, this.IsTrader,this.ostatnieParametry,"Modul", this.GetPrevParams(position, module)).
            subscribe((data) => {
                var moduleFooterControlls = data.Controlls.filter(x => x.Section == "ModuleFooter");
                data.Controlls = data.Controlls.filter(x => x.Section == "Position");
                this.isCache = true;
                this.ostatniKrok = data;
                this.moduly[module - 1].pozycje[position - 1].Valuation = null;
                // console.log("edytowanie poz", this.Parameters);
                var k:KrokStep = data;
                k.Module = module;
                k.Position = position;
                var step:KrokStep = new KrokStep(k, this.Parameters, []);
                while(this.moduly.length < module){
                    this.moduly.push(new ModulMulti());
                    // console.log("dodaje modul", module);
                }
                // console.log("edytuje pozycje", position);
                
                    // this.moduly[module - 1].pozycje.splice(position - 1 ,1, step);
                    this.EdytujKrok(this.moduly[module - 1].pozycje[position - 1], step);

                if(moduleFooterControlls.length > 0){
                    data.Controlls = moduleFooterControlls;
                    var k2:KrokStep = data;
                    k2.Position = 0;
                    k2.Module = module;
                    
                    var step2:KrokStep = new KrokStep(k2, this.Parameters, []);
                    
                    if(this.moduly[module - 1].moduleFooter == null){
                        this.moduly[module - 1].moduleFooter = step2;
                    }
                    this.EdytujKrok(this.moduly[module - 1].moduleFooter, step2);
                }
             

             this.czyPoprawne();

            }, (err) => {
                // console.log("blad zapisu");
                this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
            }, () => {
              // console.log("skonczyl position");
                this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
            });
        }
         
        
    }

    EdytujKrok(krokEdytowany:KrokStep, krokNowy:KrokStep){
        
        krokEdytowany.IsFooter = krokNowy.IsFooter;
        krokEdytowany.IsModule = krokNowy.IsModule;
        krokEdytowany.IsModuleFooter = krokNowy.IsModuleFooter;
        krokEdytowany.Module = krokNowy.Module;
        krokEdytowany.Parameters = krokNowy.Parameters;
        krokEdytowany.Position = krokNowy.Position;
        krokEdytowany.Step = krokNowy.Step;
        krokEdytowany.TechDate = krokNowy.TechDate;
        krokEdytowany.TechVersion = krokNowy.TechVersion;
        krokEdytowany.Type = krokNowy.Type;
        krokEdytowany.ValuationTechDate = krokNowy.ValuationTechDate;
        krokEdytowany.ValuationVersion = krokNowy.ValuationVersion;
        krokEdytowany.Controlls.forEach(conE => {
            conE.wystapil = false;
        });
        krokEdytowany.Controlls.forEach(conE => {
            krokNowy.Controlls.forEach(conN => {
                if(conN.KeyName == conE.KeyName){
                    conE.wystapil = true;
                    // if(conN.ControlType == "RadioImg"){
                     //    conE.ControlType = "Select";
                    // } else {
                        conE.ControlType = conN.ControlType;
                    // }
                    
                    conE.DefaultValue = conN.DefaultValue;
                    conE.Values = conN.Values;
                    conE.ValuesMultiColumn = conN.ValuesMultiColumn;
                    conE.OtherParams = conN.OtherParams;
                    conE.Parameters = conN.Parameters;
                    conE.Hidden = conN.Hidden;
                    conE.Width = conN.Width;
                    conE.PictureWidth = conN.PictureWidth;
                    conE.PictureCode = conN.PictureCode;
                    conE.ControlTypeInTinterpreter = conN.ControlTypeInTinterpreter;
                    conE.Section = conN.Section;
                    if(conN.ControlType == "Hidden" || conN.ControlType == "Label"){
                        conE.wybrany = conN.wybrany;
                    }
                    
                }
            });
        });
        krokNowy.Controlls.forEach(conN => {
            var byl = false;
             krokEdytowany.Controlls.forEach(conE => {
                if(conN.KeyName == conE.KeyName){
                    byl = true;
                }
             });
             if(!byl){
                conN.wystapil = true;
                krokEdytowany.Controlls.push(conN);
             }
        });
        krokEdytowany.Controlls.forEach(conE => {
            if(!conE.wystapil){
                conE.ControlType = "Usunieta";
            }
        });
    }
UsunZestaw(numer_mod){
    this.moduly.splice(numer_mod ,1);
    if(numer_mod > this.moduly.length - 1){
        this.widoczny_modul = numer_mod - 1;
    }
    this.ustawModPoz(0, null);
    this.Parameters = this.Parameters.filter(x => x.Module != numer_mod + 1);
    this.Parameters.forEach(par => {
        if(par.Module > numer_mod){
            par.Module = par.Module.valueOf();
        }
    });
}
KopiujZestaw(numer){
        if(this.wczytywanie <= 0 && !this.wczytywanie_wyceny){
   
            this.moduly.push(_.cloneDeep(this.moduly[numer]));
            this.widoczny_modul =  this.moduly.length -1;
            this.ustawModPoz(0, null);
        }
}
    UsunPoz(numer_mod, p:number) {

        this.moduly[numer_mod].pozycje.splice(p ,1);

        this.Parameters.forEach(par => {
            if(par.Module == numer_mod + 1 && par.Position == p + 1){
                par.Position = 999999;
            } else if(par.Module == numer_mod + 1 && par.Position > p + 1){
                par.Position = par.Position.valueOf() - 1;
            }
        });

        for(var i = p; i< this.moduly[numer_mod].pozycje.length;i++){
            //this.moduly[numer_mod].pozycje[i].Module = this.moduly[numer_mod].pozycje[i].Module.valueOf() - 1;
            this.moduly[numer_mod].pozycje[i].Position = this.moduly[numer_mod].pozycje[i].Position.valueOf() - 1;
            this.moduly[numer_mod].pozycje[i].Controlls.forEach(con => {
                con.Position = con.Position.valueOf() - 1;
            });
        }
        // console.log("Parameters po usunieciu", this.Parameters);
    }
    Add(formService:FormV2ServiceService, numer_mod){
        // console.log("Add f", numer_mod);
        
         this.wczytywanie++;
            // console.log("wczytuje Add");
            

        
        formService.getStepMulti(this.systemPrefix, this.culture, this.isCache, this.IsTrader,this.GetParams(this.moduly[numer_mod].pozycje.length + 1, numer_mod + 1),"Modul", this.GetPrevParams(this.moduly[numer_mod].pozycje.length + 1, numer_mod + 1)).
          subscribe((data) => {
                data.Controlls = data.Controlls.filter(x => x.Section == "Position");
            this.isCache = true;
             // console.log(data, this.Parameters);
             var k:KrokStep = data;
             k.Module = numer_mod + 1;
             k.Position = this.moduly[numer_mod].pozycje.length+1;
             var step:KrokStep = new KrokStep(k, this.Parameters, []);
             while(this.moduly.length < this.widoczny_modul){
                this.moduly.push(new ModulMulti());
             }
             this.moduly[numer_mod].pozycje.push(step);
             this.czyPoprawne();

             // var i = 1;
           /* this.moduly.forEach(element => {
                element.Position = i++;
            });*/
      
            // this.wczytywanie--;
          }, (err) => {
            // console.log("blad zapisu");
            this.wczytywanie--;
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          }, () => {
              // console.log("po zapisie");
              this.wczytywanie--;
              // console.log("skonczyl Add");
              if(this.wczytywanie < 0){
                    this.wczytywanie = 0;
              }
          });
        return false;
        
    }



     GetParams(numer_poz, numer_mod) {
        // console.log("num", numer_mod, numer_poz);
        if(this.naglowek == null){
             var p:Parameter[] = [];
             if(this.naglowekW != null){
                 this.naglowekW.Controlls.forEach(con => {
                    if(con.wybrany.Key != 'X'){
                        this.DodajDoParam(p, con, 0, 0);
                    }
                });
             }

             this.DodajDoParamString(p,"TAK", 0, 0, "Wycena");
            return p;
        } else {
            var wyliczane: Parameter[] = [];
            var p:Parameter[] = [];

            if(this.naglowekW != null){
                 this.naglowekW.Controlls.forEach(con => {
                    if(con.wybrany.Key != 'X'){
                        this.DodajDoParam(p, con, 0, 0);
                    }
                });
             }

             this.naglowek.Controlls.forEach(con => {
                    // console.log('ng', con);
                    
                    if(con.wybrany.Key != 'X'){
                        //p.push(con.wybrany);
                        this.DodajDoParam(p, con, 0, 0);
                    }
                });
            if(numer_mod > 0 && this.moduly.length <= numer_mod){
                this.moduly[numer_mod - 1].moduleNg.Controlls.forEach(con => {
                    // console.log('ng', con);
                    
                    if(con.wybrany.Key != 'X'){
                        //p.push(con.wybrany);
                        this.DodajDoParam(p, con, numer_mod, 0);
                        this.WyliczDodatkowe(wyliczane, con.wybrany);
                    }
                });
                if(this.moduly[numer_mod - 1].moduleFooter != null){
                    this.moduly[numer_mod - 1].moduleFooter.Controlls.forEach(con => {
                        // console.log('ng', con);
                        
                        if(con.wybrany.Key != 'X'){
                            //p.push(con.wybrany);
                            this.DodajDoParam(p, con, numer_mod, 0);
                            this.WyliczDodatkowe(wyliczane, con.wybrany);
                        }
                    });
                }
               
            }
                
               // console.log("numer", numer_poz, this.moduly[numer_mod].pozycje.length);
             if(numer_poz > 0 && numer_mod > 0 && this.moduly.length > numer_mod - 1 && numer_poz <= this.moduly[numer_mod - 1].pozycje.length){
                
                this.moduly[numer_mod - 1].pozycje[numer_poz - 1].Controlls.forEach(con => {
                    // console.log('poz ' + numer_poz , con);
                    if(con.wybrany.Key != 'X'){
                        //p.push(con.wybrany);
                        this.DodajDoParam(p, con, numer_mod, numer_poz);
                        this.WyliczDodatkowe(wyliczane, con.wybrany);
                    }
                });
             } 

             

             wyliczane.forEach(w => {
                p.push(w);
             });
             this.DodajDoParamString(p,"TAK", 0, 0, "WycenaUproszczona");
             this.DodajDoParamString(p,"TAK", 0, 0, "Wycena");
             return p;
                
        }
        
     }
     GetPrevParams(numer_poz, numer_mod) {
        // console.log("GetPrevParams",numer_poz);
        if(this.generatePrev){
            if(this.naglowek == null){
                return [];
            } else {
                numer_poz--;
                var p:Parameter[] = [];
                this.naglowek.Controlls.forEach(con => {
                        // console.log('ng', con);
                        
                        if(con.wybrany.Key != 'X'){
                            //p.push(con.wybrany);
                            this.DodajDoParam(p, con, 0, 0);
                        }
                    });
                if(numer_mod > 0 && this.moduly.length <= numer_mod){
                this.moduly[numer_mod - 1].moduleNg.Controlls.forEach(con => {
                        // console.log('ng', con);
                        
                        if(con.wybrany.Key != 'X'){
                            //p.push(con.wybrany);
                            this.DodajDoParam(p, con, numer_mod, 0);
                        }
                    });
                }
                    
                // console.log("numer", numer_poz);
                if(numer_poz > 0 && numer_mod > 0 && this.moduly.length > numer_mod - 1 && numer_poz <= this.moduly[numer_mod - 1].pozycje.length){
                    
                    this.moduly[numer_mod - 1].pozycje[numer_poz - 1].Controlls.forEach(con => {
                        // console.log('poz ' + numer_poz , con);
                        if(con.wybrany.Key != 'X'){
                            //p.push(con.wybrany);
                            this.DodajDoParam(p, con, numer_mod, numer_poz);
                        }
                    });
                } 
                this.DodajDoParamString(p,"TAK", 0, 0, "WycenaUproszczona");
                return p;
                    
            }
        } else {
            return [];
        }
       
     }

     WyliczDodatkowe(wyliczane: Parameter[], wybrany: Parameter) {
             if (!isNaN(wybrany.Value)) {
                 var suma = wyliczane.find(x=> x.Key == "suma_" + wybrany.Key);
                 var min = wyliczane.find(x=> x.Key == "min_" + wybrany.Key);
                 var max = wyliczane.find(x=> x.Key == "max_" + wybrany.Key);
                 if(suma != null){
                     suma.DisplayValue =suma.Value*1+ wybrany.Value*1;  
                     suma.DisplayValueCs =suma.Value*1+ wybrany.Value*1;  
                     suma.DisplayValueDe = suma.Value*1+ wybrany.Value*1;  
                     suma.DisplayValueEn = suma.Value*1+ wybrany.Value*1;  
                     suma.DisplayValueFr = suma.Value*1+ wybrany.Value*1;  
                     suma.DisplayValueIt = suma.Value*1+ wybrany.Value*1;  
                     suma.DisplayValuePl = suma.Value*1+ wybrany.Value*1;  
                     suma.Value = suma.Value*1+ wybrany.Value*1;  
                 } else {
                     var p:Parameter = new Parameter();
                     p.Key = "suma_"+wybrany.Key;
                     p.Value = wybrany.Value*1;
                     p.DisplayValue = wybrany.Value*1;
                     p.DisplayValueCs = wybrany.Value*1;
                     p.DisplayValueDe = wybrany.Value*1;
                     p.DisplayValueEn = wybrany.Value*1;
                     p.DisplayValueFr = wybrany.Value*1;
                     p.DisplayValueIt = wybrany.Value*1;
                     p.DisplayValuePl = wybrany.Value*1;
                     p.Module = wybrany.Module;
                     p.IsHidden = true;
                     p.ControlName = 'Hidden';
                     p.Position = 0;
                     p.Type = 3;
                     wyliczane.push(p); 
                 }
                 if(min != null){
                     if(wybrany.Value*1 < min.Value*1){ 
                         min.Value = wybrany.Value*1; 
                         min.DisplayValue = wybrany.Value*1;
                         min.DisplayValueCs = wybrany.Value*1;
                         min.DisplayValueDe = wybrany.Value*1;
                         min.DisplayValueEn = wybrany.Value*1;
                         min.DisplayValueFr = wybrany.Value*1;
                         min.DisplayValueIt = wybrany.Value*1;
                         min.DisplayValuePl = wybrany.Value*1;
                     }
                 } else {
                     var p:Parameter = new Parameter();
                     p.Key = "min_"+wybrany.Key;
                     p.Value = wybrany.Value*1;
                     p.DisplayValue = wybrany.Value*1;
                     p.DisplayValueCs = wybrany.Value*1;
                     p.DisplayValueDe = wybrany.Value*1;
                     p.DisplayValueEn = wybrany.Value*1;
                     p.DisplayValueFr = wybrany.Value*1;
                     p.DisplayValueIt = wybrany.Value*1;
                     p.DisplayValuePl = wybrany.Value*1;
                     p.IsHidden = true;
                     p.ControlName = 'Hidden';
                     p.Module = wybrany.Module;
                     p.Position = 0;
                     p.Type = 3;
                     wyliczane.push(p);
                 }
                 if(max != null){
                     if(wybrany.Value*1 > max.Value*1){
                         max.Value = wybrany.Value*1;
                         max.DisplayValue = wybrany.Value*1;
                         max.DisplayValueCs = wybrany.Value*1;
                         max.DisplayValueDe = wybrany.Value*1;
                         max.DisplayValueEn = wybrany.Value*1;
                         max.DisplayValueFr = wybrany.Value*1;
                         max.DisplayValueIt = wybrany.Value*1;
                         max.DisplayValuePl = wybrany.Value*1;
                     }
                 } else {
                     var p:Parameter = new Parameter();
                     p.Key = "max_"+wybrany.Key;
                     p.Value = wybrany.Value*1; 
                     p.DisplayValue = wybrany.Value*1;
                     p.DisplayValueCs = wybrany.Value*1;
                     p.DisplayValueDe = wybrany.Value*1;
                     p.DisplayValueEn = wybrany.Value*1;
                     p.DisplayValueFr = wybrany.Value*1;
                     p.DisplayValueIt = wybrany.Value*1;
                     p.DisplayValuePl = wybrany.Value*1;
                     p.IsHidden = true;
                     p.ControlName = 'Hidden';
                     p.Module = wybrany.Module;
                     p.Position = 0;
                     p.Type = 3;
                     wyliczane.push(p);
                 }
                 
             }
         }
      
    GetSystem(){
        this.Parameters.forEach(element => {
            if(element.Key == 'Jakatechnologia'){
                          

                switch (element.Value) { 
                    case ('PERGOLA'):{ 
                        this.system = 'Pergola';
                        break;
                     }  
                    case ('MARKIZA'): {    
                        this.system = 'Markiza';
                        break;
                    }  
                    case ('REFLEKSOL'): {    
                        this.system = 'Refleksol';
                        break;
                    }  
                }
            }
        });
    }

    GetSystemByTyp(typ:string){
                          

                switch (typ) { 
                    case ('PG'):{ 
                        this.system = 'Pergola';
                        break;
                     }  
                    case ('MARKIZA'): {    
                        this.system = 'Markiza';
                        break;
                    }  
                    case ('FAS'): {    
                        this.system = 'FS';
                        break;
                    }  
                    case ('PERGOLAV'): {    
                        this.system = 'MP';
                        break;
                    }  
                    case ('SB'): {    
                        this.system = 'SB';
                        break;
                    }  
                    case ('WG'): {    
                        this.system = 'WG';
                        break;
                    }  
                    case ('MARKIZADETALE'): {    
                        this.system = 'MAD';
                        break;
                    }  
                    case ('VERANDA'): {    
                        this.system = 'MV';
                        break;
                    }  
                    case ('FASDET'): {    
                        this.system = 'FSD';
                        break;
                    }  
                    case ('FR'): {    
                        this.system = 'Refleksol';
                        break;
                    }  
                }
    }
      GetTyp() {
        // console.log(this.Parameters);
  this.Parameters.forEach(element => {
            if(element.Key == 'Jakatechnologia'){
                          

                switch (element.Value) { 
                    case ('PERGOLA'):{ 
                        this.typ = 'PG';
                        this.systemPrefix = "X" + this.typ;
                        break;
                     }  
                    case ('MARKIZA'): {    
                        this.typ = 'MA';
                        this.systemPrefix = "X" + this.typ;
                        break;
                    }  
                    case ('FAS'): {    
                        this.typ = 'FS';
                        this.systemPrefix = "X" + this.typ;
                        break;
                    }  
                    case ('PERGOLAV'): {    
                        this.typ = 'MP';
                        this.systemPrefix = "X" + this.typ;
                        break;
                    }  
                    case ('SB'): {    
                        this.typ = 'SB';
                        this.systemPrefix = "X" + this.typ;
                        break;
                    }  
                    case ('WG'): {    
                        this.typ = 'WG';
                        this.systemPrefix = "X" + this.typ;
                        break;
                    }  
                    case ('MARKIZADETALE'): {    
                        this.typ = 'MAD';
                        this.systemPrefix = "X" + this.typ;
                        break;
                    }  
                    case ('VERANDA'): {    
                        this.typ = 'MV';
                        this.systemPrefix = "X" + this.typ;
                        break;
                    }  
                    case ('FASDET'): {    
                        this.typ = 'FSD';
                        this.systemPrefix = "X" + this.typ;
                        break;
                    }  
                    case ('REFLEKSOL'): {    
                        this.typ = 'FR';
                        this.systemPrefix = "X" + this.typ;
                        break;
                    }  
                }
            }
        });
      }
    
    
      createImageFromBlob(image: Blob, con:Control) {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          con.src = reader.result;
        }, false);
    
        if (image) {
          reader.readAsDataURL(image);
        }
      }
     

      public blobToBase64(blob) {
        return new Promise((resolve, _) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      }
      
      DodajDoParam(p:Parameter[],wparam:Control, mod:Number, poz:Number){
        if(wparam.wybrany.Value == null || wparam.wybrany.Module == null || wparam.wybrany.Position == null || wparam.wybrany.Type == null){
            // console.log(wparam);
        }
        if(wparam.ControlType != "Pokaz"){
            wparam.wybrany.IsPrint = wparam.IsPrint;
            wparam.wybrany.Module = mod.valueOf();
            wparam.wybrany.Position = poz.valueOf();
            wparam.wybrany.IsHidden = wparam.Hidden;
            wparam.wybrany.ControlName  =   wparam.ControlType;
            /*if(wparam.wybrany.Type == null){
                if(mod == 0 && poz == 0){
                    wparam.wybrany.Type =0;
                }
            }*/
          
            if(wparam.wybrany.Value != null){
                if(wparam.ControlType == "CheckNumber" || wparam.ControlType == "CheckSelect" || wparam.ControlType == 'CheckSelectMultiColumn'){
                    if(wparam.wybrany.Value != ''){
                        var index = p.findIndex(x => x.Key == wparam.KeyName && x.Module == wparam.wybrany.Module && x.Position == wparam.wybrany.Position);
                        if(index < 0){
                            p.push(wparam.wybrany);
                        } else {
                            this.Duplikat(p, p[index]);
                            p[index] = wparam.wybrany;
                        }
                    }
                } else if(wparam.ControlType == "Number" || wparam.ControlType == "Text" ){
                    wparam.wybrany.DisplayValue = wparam.wybrany.Value;
                    wparam.wybrany.DisplayValueCs= wparam.wybrany.Value;
                    wparam.wybrany.DisplayValueDe = wparam.wybrany.Value;
                    wparam.wybrany.DisplayValueEn = wparam.wybrany.Value;
                    wparam.wybrany.DisplayValueFr = wparam.wybrany.Value;
                    wparam.wybrany.DisplayValueIt = wparam.wybrany.Value;
                    wparam.wybrany.DisplayValuePl = wparam.wybrany.Value;

                    var index = p.findIndex(x => x.Key == wparam.KeyName && x.Module == wparam.wybrany.Module && x.Position == wparam.wybrany.Position);
                    if(index < 0){
                        p.push(wparam.wybrany);
                    } else {
                        this.Duplikat(p, p[index]);
                        p[index] = wparam.wybrany;
                    }
                } else if(wparam.ControlType == "Pergola" ){
                    // console.log("par", wparam);
                    var index = p.findIndex(x => x.Key == wparam.KeyName && x.Module == wparam.wybrany.Module && x.Position == wparam.wybrany.Position);
                    wparam.wybrany.IsPrint = false;
                    if(index < 0){
                        p.push(wparam.wybrany);
                    } else {
                        this.Duplikat(p, p[index]);
                        p[index] = wparam.wybrany;
                    }
                } else {
                    // console.log("par", wparam);
                    var index = p.findIndex(x => x.Key == wparam.KeyName && x.Module == wparam.wybrany.Module && x.Position == wparam.wybrany.Position);
                    if(index < 0){
                        p.push(wparam.wybrany);
                    } else {
                        this.Duplikat(p, p[index]);
                        p[index] = wparam.wybrany;
                    }
                }
                
                
            }

           
            /* else if(wparam.ControlType == "CheckNumber" || wparam.ControlType == "CheckSelect" || wparam.ControlType == 'CheckSelectMultiColumn'){
                // console.log("par null", wparam);
                wparam.wybrany.Value = '';
                wparam.wybrany.Key  =   wparam.KeyName;
                var index = p.findIndex(x => x.Key == wparam.KeyName && x.Module == wparam.wybrany.Module && x.Position == wparam.wybrany.Position);
                if(index < 0){
                    p.push(wparam.wybrany);
                } else {
                    p[index] = wparam.wybrany;
                }
            } */
            
                


        }
    }
    DodajDoParamString(p:Parameter[],value:string, mod:Number, poz:Number, key:string){
        var param = new Parameter();
                    param.DisplayValue = value;
                    param.DisplayValueCs= value;
                    param.DisplayValueDe = value;
                    param.DisplayValueEn = value;
                    param.DisplayValueFr = value;
                    param.DisplayValueIt = value;
                    param.DisplayValuePl = value;
                    param.Value = value;
                    param.Module = mod.valueOf();
                    param.Position= poz.valueOf();
                    param.Key = key;
                
              p.push(param);
    }
   Duplikat(parametry: Parameter[], wybrany: Parameter) {
        // console.log("Dubel", wybrany);
        // this.duplikat = true;
        var p:Parameter = new Parameter();
        p.Key = "duplikat_"+wybrany.Key;
        p.Value = wybrany.Value;
        p.DisplayValue = wybrany.Value;
        p.DisplayValueCs = wybrany.Value;
        p.DisplayValueDe = wybrany.Value;
        p.DisplayValueEn = wybrany.Value;
        p.DisplayValueFr = wybrany.Value;
        p.DisplayValueIt = wybrany.Value;
        p.DisplayValuePl = wybrany.Value;
        p.Module = wybrany.Module;
        p.IsHidden = true;
        p.ControlName = 'Hidden';
        p.Position = wybrany.Position;
        p.Type = wybrany.Type;
        parametry.push(p); 
    }

  }
 


 

  


  